import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { DistributionModel } from '../../../models/distribution.model';
import { DistributionBlockTypeEnum } from '../../../enums/distribution-block-type.enum';
import { TextStyleFieldModel } from '../../../../../Common/PageBuilder/models/text-style-field.model';
import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { DistributionService } from '../../../../../Common/TargetingShared/services/distribution.service';
import { GenericStyleModel } from '../../../../../Common/Styles/models/generic-style.model';
import { DistributionStyleStateEnum } from '../../../../../Common/TargetingShared/enum/distribution-style-state.enum';
import {
    distributionButtonBlockInnerStyleField,
    distributionDividerBlockInnerStyleField,
    distributionFooterBlockInnerStyleField,
    distributionImageBlockInnerStyleField,
    distributionTextBlockInnerStyleField,
    distributionTitleBlockInnerStyleField,
    distributionLinkBlockInnerStyleField,
    distributionOneColumnLayoutBlockInnerStyleField,
    distributionTwoColumnLayoutBlockInnerStyleField,
    distributionThreeColumnLayoutBlockInnerStyleField
} from '../../../../../Common/TargetingShared/model/distribution-block-types.model';
import { DividerStyleFieldModel } from '../../../../../Common/PageBuilder/models/divider-style-field.model';
import { ButtonStyleFieldModel } from '../../../../../Common/PageBuilder/models/button-style-field.model';
import { LinksStyleFieldModel } from '../../../../../Common/PageBuilder/models/links-style-field.model';
import { DisplayElementModel } from '../../../../../Common/PageBuilder/models/display-element.model';
import { LayoutStyleField } from '../../../../../Common/PageBuilder/models/layout-style-field.model';

@Component({
    selector: 'agpr-distribution-global-customization',
    templateUrl: './distribution-global-customization.component.html',
    styleUrls: ['./distribution-global-customization.component.scss'],
    standalone: false
})
export class DistributionGlobalCustomizationComponent implements OnInit, OnDestroy {
    @Input() public id: string;

    focusedDistribution: DistributionModel;
    subscriptions: Subscription[] = [];

    distributionBlockTypeEnum = DistributionBlockTypeEnum;

    imageField: TextStyleFieldModel;
    titleField: TextStyleFieldModel;
    textField: TextStyleFieldModel;
    dividerField: DividerStyleFieldModel;
    buttonField: ButtonStyleFieldModel;
    linkField: LinksStyleFieldModel;
    oneColumnLayoutField: LayoutStyleField;
    twoColumnLayoutField: LayoutStyleField;
    threeColumnLayoutField: LayoutStyleField;
    footerField: TextStyleFieldModel;
    footerDisplayElement: DisplayElementModel;

    readonly buttonTypes = ButtonTypesEnum;

    constructor(
        private coreDialogService: CoreDialogService,
        private distributionService: DistributionService
    ) {}

    ngOnInit() {
        this.subscriptions.push(
            this.distributionService.getFocusedResource().subscribe(
                focusedDistribution => {
                    if (focusedDistribution) {
                        this.focusedDistribution = focusedDistribution;
                        this.footerDisplayElement =
                            this.focusedDistribution.blocks.find(block => block.type.key === DistributionBlockTypeEnum.footer).displayElement;
                    }
                }
            )
        );

        this.imageField = JSON.parse(JSON.stringify(distributionImageBlockInnerStyleField));
        this.imageField.property = DistributionBlockTypeEnum.image;

        this.titleField = JSON.parse(JSON.stringify(distributionTitleBlockInnerStyleField));
        this.titleField.property = DistributionBlockTypeEnum.title;

        this.textField = JSON.parse(JSON.stringify(distributionTextBlockInnerStyleField));
        this.textField.property = DistributionBlockTypeEnum.text;

        this.dividerField = JSON.parse(JSON.stringify(distributionDividerBlockInnerStyleField));
        this.dividerField.property = DistributionBlockTypeEnum.divider;

        this.buttonField = JSON.parse(JSON.stringify(distributionButtonBlockInnerStyleField));
        this.buttonField.property = DistributionBlockTypeEnum.button;

        this.linkField = JSON.parse(JSON.stringify(distributionLinkBlockInnerStyleField));
        this.linkField.property = DistributionBlockTypeEnum.link;

        this.oneColumnLayoutField = JSON.parse(JSON.stringify(distributionOneColumnLayoutBlockInnerStyleField));
        this.oneColumnLayoutField.property = DistributionBlockTypeEnum.oneColumnLayout;

        this.twoColumnLayoutField = JSON.parse(JSON.stringify(distributionTwoColumnLayoutBlockInnerStyleField));
        this.twoColumnLayoutField.property = DistributionBlockTypeEnum.twoColumnLayout;

        this.threeColumnLayoutField = JSON.parse(JSON.stringify(distributionThreeColumnLayoutBlockInnerStyleField));
        this.threeColumnLayoutField.property = DistributionBlockTypeEnum.threeColumnLayout;

        this.footerField = JSON.parse(JSON.stringify(distributionFooterBlockInnerStyleField));
        this.footerField.property = DistributionBlockTypeEnum.footer;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    /**
     * Handles changes to date style
     */
    styleChange(styleModel: GenericStyleModel, blockType: DistributionBlockTypeEnum): void {
        if (!styleModel.isSavedStyle() && (styleModel as any).displayStyleState !== DistributionStyleStateEnum.CUSTOM) {
            const defaultStyle = this.distributionService.getDefaultStyle(blockType, styleModel.styleState as DistributionStyleStateEnum);
            defaultStyle.template = null;
            if (blockType === DistributionBlockTypeEnum.footer) {
                if (this.footerDisplayElement) {
                    this.footerDisplayElement.styles = defaultStyle.clone();
                }
            } else {
                this.focusedDistribution?.generalStyles?.setProperty(blockType, defaultStyle.clone());
            }
            this.distributionService.generalStylesBlockUpdated(blockType, defaultStyle);

            return;
        }

        if (blockType === DistributionBlockTypeEnum.footer) {
            if (this.footerDisplayElement) {
                this.footerDisplayElement.styles = styleModel.clone();
            }
        } else {
            this.focusedDistribution?.generalStyles?.setProperty(blockType, styleModel.clone());
        }
        this.distributionService.generalStylesBlockUpdated(blockType, styleModel);
    }
}
